import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { patchActivateState } from '../../utils/api-calls/patchActivateState';
import { Chatroom } from '../../models';
import { ChatroomStatus } from '../../models/chatroomStatus';
import { useTranslation } from 'react-i18next';

type ActivateConfirmModalProps = {
  room: Chatroom;
  toggleModal: (display: boolean, room?: Chatroom) => void;
};

export function ActivateConfirmModal({
  room,
  toggleModal,
}: ActivateConfirmModalProps) {
  const [t] = useTranslation(['chatroom']);
  const navigate = useNavigate();
  const onLaterClick = () => {
    toggleModal(false);
  };
  const onStartClick = async () => {
    try {
      const { activity } = room;
      const startAt = Date.now();
      const endAt = dayjs().add(activity.duration, 'day').valueOf();
      await patchActivateState(room, true);

      const tmpRoom: Chatroom = {
        ...room,
        activity: {
          ...room.activity,
          startAt,
          endAt,
        },
        status: ChatroomStatus.NEW,
      };

      toggleModal(false);
      navigate(`/chatrooms/${room.id}`, { state: { room: tmpRoom } });
    } catch (e) {
      console.error(e);
    }
  };

  return room ? (
    <div className="bg-white flex flex-col p-6 w-full rounded-lg">
      <span className="w-full flex justify-center text-xl font-semibold mb-6">
        {t('activate_activity_confirm_title', '啟動「{{chatroom}}」活動嗎？', {
          chatroom: room.activity.name,
        })}
      </span>
      <span className="mb-10">
        {t(
          'activate_activity_confirm_description',
          '機器人將從今天開始推送任務'
        )}
      </span>
      <div className="flex flex-row gap-4 w-full">
        <button
          className="border border-group-primary rounded text-group-primary text-lg text-center flex-grow py-2"
          onClick={onLaterClick}
        >
          {t('activate_activity_later', '稍候啟動')}
        </button>
        <button
          className="bg-group-primary rounded text-white text-lg text-center flex-grow py-2"
          onClick={onStartClick}
        >
          {t('activate_activity_immediately', '立刻啟動')}
        </button>
      </div>
    </div>
  ) : (
    <></>
  );
}
